/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerRmaItem } from './customerRmaItem';
import { RmaAttachmentGetDto } from './rmaAttachmentGetDto';
import { CustomerDeclarationDto } from './customerDeclarationDto';


export interface CustomerRma { 
    id: string;
    insertionTimestamp: string;
    formattedRmaNumber: string;
    rmaNumber?: number;
    customerName: string;
    customerOrganization: string;
    additionalEmailAddress?: string;
    comment?: string;
    quoteBeforeShipping?: boolean;
    packageReceivedTimestamp?: string;
    dataIsAvailableInInventa?: boolean;
    declarations: Array<CustomerDeclarationDto>;
    items: Array<CustomerRmaItem>;
    numberOfOtherDevices?: number;
    rmaStatus: CustomerRma.RmaStatusEnum;
    attachments?: Array<RmaAttachmentGetDto>;
}
export namespace CustomerRma {
    export const RmaStatusEnum = {
        Created: 'Created',
        PackageReceived: 'PackageReceived',
        DeviceInspection: 'DeviceInspection',
        Quotation: 'Quotation',
        InConfiguration: 'InConfiguration',
        InRefurbishment: 'InRefurbishment',
        Completed: 'Completed'
    } as const;
    export type RmaStatusEnum = typeof RmaStatusEnum[keyof typeof RmaStatusEnum];
}


